export { default as onSubmitMultiplier } from './onSubmitMultiplier';

export type {
    OnSubmitMultiplierFunction, OnSubmitMultiplierPayload
} from './onSubmitMultiplier.type';
;
